<template>
  <div class="tree-people">
    <div class="search" v-if="isSearch">
      <el-input
        class="gray white"
        :placeholder="placeholder"
        prefix-icon="el-icon-search"
        v-model="filterText"
        clearable
      >
      </el-input>
    </div>
    <el-tree
      :ref="refStr"
      node-key="id"
      :filter-node-method="filterNode"
      :data="list"
      :props="defaultProps"
      show-checkbox
      :highlight-current="true"
      :expand-on-click-node="false"
      @check-change="handleNodeCheck"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span v-if="data.children" class="iconfont" style="margin-right: 16px">
          <img :src="data.img">
        </span>
        <span v-else class="children-img" style="margin-right: 16px">
          <img :src="data.img">
        </span> 
        <span>{{ node.label}}</span>          
      </span>
    </el-tree>
  </div>
</template>

<script>
export default {
  props: {
    refStr: {
      type: String,
      default: 'tree'
    },
    departmentId: {
      type: Number
    },
    companyList: {
      type: Array
    },
    selectData: {
      type: Array
    },
    isSwitchImg: {
      type: Boolean,
      default: true
    },
    /* 是否启用搜索 */
    isSearch: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: '搜索部门名'
    },

    /* 只有那你级可以选择， 1：选择3级部门 2，选择4级部门 */
    firstImg: {
      type: String,
      default: require('../../assets/tree/first.png')
    },
    firstHighImg: {
      type: String,
      default: require('../../assets/tree/first-high.png')
    },
    secondImg: {
      type: String,
      default: require('../../assets/tree/second.png')
    },
    secondHighImg: {
      type: String,
      default: require('../../assets/tree/second-high.png')
    },
    threeSpotImg: {
      type: String,
      default: require('../../assets/tree/three-spot.png')
    },
    threeSpotHighImg: {
      type: String,
      default: require('../../assets/tree/three-spot-high.png')
    },
    bookImg: {
      type: String,
      default: require('../../assets/tree/book.png')
    },
    randomImg: {
      type: String,
      default: require('../../assets/tree/random.png')
    }
  },

  data() {
    return {
      defaultProps: {
        children: "subList",
        label: "departmentName"
      },
      filterText: '',
      id: this.departmentId,
      list: this.companyList,
      selectData1: this.selectData,
    }
  },
  watch: {
    filterText(val) {
      this.$refs[this.refStr].filter(val);
    },
  },

  created() {
    this.mapId(this.list, this.id)
  },
  
  mounted () {
    this.$nextTick(() => {
      this.initLighDate(this.selectData1)
    })
    this.$bus.on('allTreeCheckedDel', v => {
      this.$nextTick(() => {
        this.initLighDate(v)
      })
    })
    this.$bus.on('allTreeCheckedLighDate', v => {
      this.$nextTick(() => {
        this.initLighDate(v)
      })
    })
    this.$bus.on('initList', v => {
      this.$nextTick(() => {
        this.list = v
        this.mapId(this.list, this.id)
      })
    })
    this.$bus.on('initSecondaryDirector', v => {
      this.$nextTick(() => {
        this.list = v
        this.mapId(this.list, this.id)
      })
    })
    this.$bus.on('allTreeclear', v => {
      this.$refs[this.refStr].setCheckedKeys([]);
      this.$nextTick(() => {
        this.$refs[this.refStr].setCheckedKeys(v);
      })
    })
  },

  methods: {
    /* tree高亮选中数据 */
    initLighDate(v) {
      let arr = []
      v.map(i => {
        arr.push(i.id)
      })
      this.$refs[this.refStr].setCheckedKeys(arr);
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.departmentName.indexOf(value) !== -1;
    },

    mapId(child, id) {
      child.map(i => {
        if (i.id === id) {
          if (i.level === 1) {
            i.img = this.isSwitchImg?this.firstHighImg:this.bookImg
          } else {
            i.img = this.isSwitchImg?this.secondHighImg:this.randomImg
          }
          i.threeSpotImg = this.threeSpotHighImg
        } else {
          if (i.level === 1) {
            i.img = this.isSwitchImg?this.firstImg:this.bookImg
          } else {
            i.img = this.isSwitchImg?this.secondImg:this.randomImg
          }
          i.threeSpotImg = this.threeSpotImg
        }
        if (i.subList && i.subList.length > 0) {
          this.mapId(i.subList, id);
        }
      })
    },
    
    handleNodeCheck() {
      let res = this.$refs[this.refStr].getCheckedNodes(true, true);
      this.$emit('selectTreeNodeList', res)
    },
  }
}
</script>

<style lang='scss'>
.tree-people {
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: $bg-ChangeDepartmentHighTree;
    color: $color-ChangeDepartmentHighTree;
  }
  .el-tree-node {
    .is-leaf + .el-checkbox .el-checkbox__inner{
        display: inline-block;
    }
    .el-checkbox.is-disabled .el-checkbox__inner{
        display: none;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
    }
  }
  .el-tree-node__content {
    height: 40px;
    line-height: 40px;
    font-size: $fs-small-l;
    color: $color-grey;
  }
  .search {
    margin-bottom: 12px;
    .el-input__prefix, .el-input__suffix {
      top: 2px;
    }
  }
}
</style>